import linearGradient from "assets/mui/functions/linearGradient";
import pxToRem from "assets/mui/functions/pxToRem";
import type { Theme, SxProps } from "@mui/material";

const sidebarStyle: SxProps = (theme: Theme) => ({
  display: "flex",
  flexDirection: "column",
  position: "sticky",
  alignSelf: "flex-start",
  justifyContent: "space-between",
  top: 0,
  width: theme.constants.SIDEBAR_WIDTH,
  height: "100vh",
  paddingTop: "50px",
  boxSizing: "border-box",
  background: linearGradient(theme.palette.box2.main, theme.palette.box2.dark),
  boxShadow: 1,
  color: theme.palette.box2.contrastText,

  "& a, & a:visited": {
    textDecoration: "none",
  },

  "& a.active > .MuiBox-root": {
    background: linearGradient("#49a3f1", "#1A73E8"),
  },
});

export const sidebarInnerStyle: SxProps = (theme: Theme) => ({
  width: theme.constants.SIDEBAR_WIDTH,
});

function linkStyle() {
  return {
    display: "flex",
    padding: "0.5rem 0.625rem",
    margin: "0.15rem 1rem",
    borderRadius: "3px",
    background: "transparent",
    fontSize: pxToRem(14),
    color: "#ffffff",
    transition:
      "box-shadow 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
    },
  };
}

const menuIconStyle: SxProps = {
  display: "flex",
  width: "1rem",
  alignItems: "center",
  marginRight: 1,
};

const HangfireItem: SxProps = {
  marginTop: 5,
};

const buildInfoStyle: SxProps = {
  padding: 1,
  opacity: 0.5,
  fontSize: 11,
  alignSelf: "left",
};

export { sidebarStyle, linkStyle, menuIconStyle, HangfireItem, buildInfoStyle };
